module.exports = __webpack_public_path__ + "img/comoros.d7b474ee.svg";